import Link from "next/link";

import { cn } from "@/lib/utils";

function PraxisMark({ className }: { className?: string }) {
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src="/brand/praxistars-mark.png?v=2"
      alt=""
      className={cn("object-contain", className)}
    />
  );
}

export function BrandMarkAvatar({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "flex size-11 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white",
        className,
      )}
      aria-hidden="true"
    >
      <PraxisMark className="size-[68%]" />
    </div>
  );
}

type BrandLogoProps = {
  href?: string;
  subtitle?: string;
  className?: string;
  compact?: boolean;
  showWordmark?: boolean;
};

export function BrandLogo({
  href = "/",
  subtitle,
  className,
  compact = false,
  showWordmark = true,
}: BrandLogoProps) {
  return (
    <Link
      href={href}
      className={cn("flex items-center gap-2.5", className)}
      aria-label="PraxisTárs"
    >
      <PraxisMark
        className={cn("shrink-0", compact ? "size-8" : "size-9")}
      />
      {showWordmark ? (
        <span className="min-w-0">
          <span className="block text-[19px] font-bold leading-none tracking-[-0.035em]">
            <span className="text-primary">Praxis</span>
            <span className="text-slate-800">Társ</span>
          </span>
          {subtitle ? (
            <span className="mt-1 block text-[11px] font-medium text-muted-foreground">
              {subtitle}
            </span>
          ) : null}
        </span>
      ) : null}
    </Link>
  );
}
